import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from '../../services/inventory.service';
import { InventoryItemFactory } from 'src/app/factories/inventory-item.factory';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-inventory-list',
  templateUrl: './inventory-list.component.html',
  styleUrls: ['./inventory-list.component.scss', '../tabs.scss']
})
export class InventoryListComponent implements OnInit {
  dataSource: MatTableDataSource<InventoryItem>;
 
  allItems: InventoryItem[] = [];
  itemsForSale: InventoryItem[] = [];
  itemsNeedImprovement: InventoryItem[] = [];
  itemsCheckedOut: InventoryItem[] = [];

  listedItems = 0;
  unlistedItems = 0;

  columnsToDisplay2 = [
    'image',
    'code',
    'title',
    'salesChannels',
    'stockTake'
  ];

  category: InventoryCategory = null;

  loading = true;

  startDate: Date = new Date();
  endDate: Date = new Date();
  weekOffset: number = 0;
  unlistedOnly = false;

  types: any[] = [];

  params: any = {};

  constructor(private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private inventoryCategoryService: InventoryCategoryService,
    private connectionService: ConnectionService) { }

  ngOnInit(): void {
    // this.inventoryService.getItemTypes().subscribe((result: any) => {
    //   this.types = result;
    // });

    this.route.params.subscribe(params => {
      this.params = params;

      if (params.category != undefined) {

        this.inventoryCategoryService.get(+params.category).subscribe((category: InventoryCategory) => {
          this.category = category;
          
          this.loadItems();
        });
      }
    });
  }

  loadItems(refreshOnly = false) {
    this.loading = true;

    let query: any = {}

    query.category = +this.category.id;

    this.inventoryService.find(query, "number", "asc").subscribe((items: InventoryItem[]) => {
      this.allItems = [];
      this.itemsForSale = [];
      this.itemsCheckedOut = [];
      this.itemsNeedImprovement = [];
      
      this.loadItemsIntoTables(items);

      if (!refreshOnly) {
        if (this.params.itemNumber) {
          for (let i=0;i < this.allItems.length; i++) {
            if (this.allItems[i].number == this.params.itemNumber) {
              this.viewItem(this.allItems[i], i, true);
            }
          }
        }
      }
    });
  }

  loadItemsIntoTables(items: InventoryItem[]) {
    this.allItems = [];
    this.itemsForSale = [];
    this.itemsCheckedOut = [];
    this.itemsNeedImprovement = [];
    this.listedItems = 0;
    this.unlistedItems = 0;
    
    // Separate into categories
    for (let item of items) {
      if (item.status == "checked-out") {
        this.itemsCheckedOut.push(item);
      } else if (item.improvementRequest != "") {
        this.itemsNeedImprovement.push(item);
      } else {
        this.itemsForSale.push(item);
      }
    }

    this.allItems.push(...this.itemsNeedImprovement);
    this.allItems.push(...this.itemsForSale);
    this.allItems.push(...this.itemsCheckedOut);

    let itemsToDisplay: InventoryItem[] = [];

    switch (this.activeTab) {
      case "active":
        itemsToDisplay = this.itemsForSale;
        break;
      case "needs-attention":
        itemsToDisplay = this.itemsNeedImprovement;
        break;
      case "checked-out":
        itemsToDisplay = this.itemsCheckedOut;
        break;        
    }

    for (let i=itemsToDisplay.length-1; i >= 0; i--) {

      if (this.inventoryService.isListed(itemsToDisplay[i])) {
        this.listedItems++;

        // Removed listed items
        if (this.unlistedOnly) {
          itemsToDisplay.splice(i, 1);
        }
      } else {
        this.unlistedItems++;
      }
    }

    this.dataSource = new MatTableDataSource<InventoryItem>(itemsToDisplay);

    this.cdr.detectChanges();
    this.loading = false;

  }

  viewItem(item: InventoryItem, currentIndex: number, onPageLoad: boolean = false) {
    let list: number[] = [];
    for (let i = 0; i < this.allItems.length; i++) {
      list.push(this.allItems[i].number);

      if (item.number == this.allItems[i].number) {
        currentIndex = i;
      }
    }

    this.inventoryService.openInventoryItemDialog(item, list, currentIndex, (r: any) => {
      if (this.category == null) {
        window.history.pushState({}, '',`/inventory`);
      } else {
        window.history.pushState({}, '',`/inventory/c/${this.category.id}`);
      }

      this.loadItems(true);
    });

    if (!onPageLoad) {
      if (this.category == null) {
        window.history.pushState({}, '',`/inventory/${item.number}`);
      } else {
        window.history.pushState({}, '',`/inventory/c/${this.category.id}/${item.number}`);
      }
    }
  }

  preventDuplicate = false;
  createItem(category: InventoryCategory) {
    
    if (!this.preventDuplicate) {
      this.preventDuplicate = true;

      this.inventoryService.create(InventoryItemFactory.new(category.id)).subscribe((item: InventoryItem)=> {
        this.preventDuplicate = false;
        this.viewItem(item, 0);
      });
    }
  }

  activeTab = "active";
  activateTab(tab: string) {
    this.activeTab = tab;
    this.loadItems(true);
  }

  showForSale = true;
  toggleForSale() {
    this.showForSale = !this.showForSale;
  }

  showNeedsImprovement = true;
  toggleNeedsImprovement() {
    this.showNeedsImprovement = !this.showNeedsImprovement;
  }

  showCheckedOut = false;
  toggleCheckedOut() {
    this.showCheckedOut = !this.showCheckedOut;
  }

  getTitle(title: string) {

    if (title == "") {
      return "Untitled";
    }
    
    return title;
  }

  filter(query: string) {
    this.dataSource.filter = query;
  }

  filterCancelled() {
    this.dataSource.filter = null;
  }

  openItemTemplateEditor() {
    this.inventoryCategoryService.openInventoryItemTemplateDialog(this.category.id, r=>{});
  }

  getImage(item: InventoryItem) {
    let x = '';
    if (item.media.length > 0) {
      let imagePath = this.connectionService.address + "/inventory/" + item.number + "/";
      if (item.media[0].filename != undefined) {      
        let y = item.media[0].filename.replace(/\(/g, '%28').replace(/\)/g, '%29');
        x = "background-image: url('" + imagePath + y + "?width=130&height=130&fit=cover');";
      }
    }
    return x;
  }

  getPlaceholder() {
    return `background-image: url('${this.connectionService.address}/inventory-category-pictures/placeholder.jpg');`;
  }

  
  showUnlistedOnly() {
    this.unlistedOnly = !this.unlistedOnly;
    this.loadItems();
  }

  openCategoriesDialog() {
    this.inventoryCategoryService.openInventoryCategoriesDialog();
  }
}